module.exports = __webpack_public_path__ + "media/images/plage privée-c12707bf7806e5b5389d5a84958a3c0e.svg";